module.exports = __webpack_public_path__ + "media/images/BG1_dark-2bf23f67e0cadeee5d12a4b5b23ac772.png";